/**
 * LA MAPPA DEI PRODOTTI ATOM E GLI ANNUNCI FERMI (4/11/2026, «ATOM · VENDITE» task 1.3).
 * Rotte gia' esistenti del backend, solo admin: `/integrations/atom/products` e `/integrations/atom/inbox`.
 */
const intestazioni = () => ({'x-access-token': localStorage.getItem('hash'), 'Content-Type': 'application/json'});

function chiama(indirizzo, opzioni, atteso) {
    return new Promise(function (resolve, reject) {
        fetch(indirizzo, Object.assign({headers: intestazioni()}, opzioni))
            .then((r) => (r.status !== 500) ? r.json() : reject({status: "SERVER_ERROR"}))
            .then((j) => {
                if (!j) return;
                global.checkAuth(j.status);
                if (j.status === atteso) resolve(j);
                else reject(j);
            })
            .catch((e) => { console.error(e && e.message); reject({status: "APP_ERROR"}); });
    });
}

const AtomProdottiAPI = {
    mappa: () => chiama(global.route.atomProducts, {method: 'GET'}, "ATOM_PRODUCTS_OK"),
    salva: (riga) => chiama(global.route.atomProducts, {method: 'PUT', body: JSON.stringify(riga)}, "ATOM_PRODUCT_SAVED"),
    togli: (id) => chiama(global.route.atomProducts + "/" + id, {method: 'DELETE'}, "ATOM_PRODUCT_DELETED"),
    fermi: () => chiama(global.route.atomInbox + "?status=blocked&limit=200", {method: 'GET'}, "ATOM_INBOX_OK"),
    rilancia: (id) => chiama(global.route.atomInbox + "/" + id + "/retry", {method: 'PUT'}, "ATOM_DELIVERY_REQUEUED")
};

export default AtomProdottiAPI;
